'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SupportedPhoneNumber;

var _SupportedPhoneNumberTypes = require('./SupportedPhoneNumberTypes');

var _SupportedPhoneNumberTypes2 = _interopRequireDefault(_SupportedPhoneNumberTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Supported countries as defined in https://knowledge.hubspot.com/articles/kcs_article/calling/what-countries-are-supported-by-calling
exports.default = (_SupportedPhoneNumber = {}, _defineProperty(_SupportedPhoneNumber, _SupportedPhoneNumberTypes2.default.SALES_HUB, ['ar', 'at', 'au', 'cx', 'cc', 'be', 'br', 'bg', 'ca', 'cl', 'cn', 'co', 'cr', 'cz', 'cy', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'in', 'ie', 'il', 'it', 'jp', 'lv', 'lt', 'lu', 'mt', 'mx', 'nl', 'nz', 'no', 'pa', 'pe', 'pl', 'pt', 'ro', 'sg', 'sk', 'za', 'kr', 'es', 'se', 'ch', 'gb', 'us']), _defineProperty(_SupportedPhoneNumber, _SupportedPhoneNumberTypes2.default.CRM, ['au', 'br', 'fr', 'de', 'ie', 'jp', 'es', 'gb', 'us']), _SupportedPhoneNumber);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/constants/SupportedPhoneNumbers.js
// module id = 565
// module chunks = 3 4 5